export const SUPPORT_EMAIL = 'idp-support@optum.com'
export const IMPLEMENTATION_EMAIL = ''
export const HUB_CONNECT = ''
export const ENHANCEMENT_REQUESTS = ''
export const APP_NAME = 'Infectious Disease Platform'
export const USER_AUTH_KEY = 'IDP_USER_AUTH'
export const USER_LOGIN_REDIRECT = 'USER_LOGIN_REDIRECT'
export const FEEDBACK_LINK = ''
